import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type UpdatePartType = ClientInferResponseBody<typeof contract.parts.updatePartType>;

type UpdatePartTypeDto = ClientInferRequest<typeof contract.parts.updatePartType>["body"];

export const updatePartType = async ({
  id,
  payload,
}: {
  id: string;
  payload: UpdatePartTypeDto;
}): Promise<UpdatePartType> => {
  const response = await api.parts.updatePartType.mutation({
    params: {
      id,
    },
    body: payload,
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to update PartType", response.status, response.body);
};
